<div class="body">
    <section>
        <h2>Condiciones especiales</h2>
    </section>
    <section>
        <form [formGroup]="manageConditionForm" (ngSubmit)="submitConditions()">
            <div class="top-form">
                <button type="button" mat-raised-button (click)="addNewCondition()">
                    <fa-icon [icon]="icons.faPlus"></fa-icon>
                    Agregar condición
                </button>
            </div>
            <div class="list-conditions-accordion">
                <mat-accordion>
                    <ng-container formArrayName="conditions">
                        <ng-container *ngFor="let item of conditions.controls; let idx = index; trackBy:trackByKey">
                            <mat-expansion-panel [formGroupName]="idx">
                                <mat-expansion-panel-header class="panel-header">
                                    <mat-panel-title>
                                        @if(item.invalid && item.touched){
                                            <fa-icon class="warn-missing-info-item" [icon]="icons.faCircleExclamation"></fa-icon>
                                        }
                                        {{ getConditionName(idx)}}
                                    </mat-panel-title>
                                    <button class="removal-btn" type="button" color="warn" (click)="removeCondition(idx)" mat-icon-button>
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </mat-expansion-panel-header>
                                <section class="content-item">
                                        <mat-form-field class="inner-autocomplete-content">
                                            <mat-label>Condición</mat-label>
                                            <input matInput aria-label="Condition"
                                            (blur)="onBlurAutoComplete($event, idx)"
                                            formControlName="selectedCondition"
                                            [matAutocomplete]="auto">
                                            <mat-autocomplete [displayWith]="displayConditionWith"                                            
                                            #auto="matAutocomplete" [requireSelection]="true"
                                            >
                                                <mat-option *ngFor="let condition of (availableConditions$ | async)" [value]="condition">
                                                    {{condition.name}}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-error *ngIf="item.get('selectedCondition').hasError('duplicate')">
                                                Condición duplicada
                                            </mat-error>
                                        </mat-form-field>        
                                    <mat-form-field>
                                        <mat-label>Descripción</mat-label>
                                        <textarea matInput formControlName="description"></textarea>
                                    </mat-form-field>
                                </section>
                            </mat-expansion-panel>
                        </ng-container>
                        <ng-container *ngIf="conditions.controls.length === 0">
                            <h3 style="text-align: center;">
                              <fa-icon
                                [style.color]="'orange'"
                                [icon]="icons.faTriangleExclamation"
                              ></fa-icon>
                              Sin condiciones a agregar
                            </h3>
                          </ng-container>
                    </ng-container>
                </mat-accordion>
            </div>
            <div class="form-action">
                <button [disabled]="manageConditionForm.invalid" type="submit" mat-raised-button color="primary">Registrar</button>
            </div>
        </form>
    </section>
</div>
